import { createFilter } from '@spotify/confidence-core-react';

import { IdentityFilterEditor, IdentityFilterViewer } from './components';

export const RESOLVE_MODE_DESCRIPTIONS: Record<string, string> = {
  remote: 'This SDK makes a network call to the backend for each flag resolve',
  cached:
    'This SDK downloads the flag configuration and resolves flags locally',
  local: 'This SDK resolves flags locally using an embedded resolver',
};

export const OWNER_FILTER = createFilter<string[]>({
  id: 'owners',
  label: 'Owner',
  hotkey: 'o',
  query: (value: string[]) => value.map(v => `owner:"${v}"`).join(' OR '),
  viewer: props => (
    <IdentityFilterViewer
      {...props}
      singularLabel="owner"
      pluralLabel="owners"
    />
  ),
  editor: IdentityFilterEditor,
});

export const CREATOR_FILTER = createFilter<string[]>({
  id: 'creators',
  label: 'Creator',
  query: (value: string[]) => value.map(v => `creator:"${v}"`).join(' OR '),
  viewer: props => (
    <IdentityFilterViewer
      {...props}
      singularLabel="creator"
      pluralLabel="creators"
    />
  ),
  editor: IdentityFilterEditor,
});
